import styled, { css } from 'styled-components';
import media from 'src/styles/Media.styled';
import {
    scrollBarStyle,
    StyledOrderDetailIPadPortrait,
} from 'src/styles/CommonStyles.styled';

export const WrapperContiner = styled.div`
    background: whitesmoke;
    height: 100%;

    ${({ isIPadPotrait }) =>
        isIPadPotrait &&
        css`
            ${StyledOrderDetailIPadPortrait}
        `};

    ${media.smalDevice`
         background: ${({ iPadPortraitBackgroundColor }) =>
             iPadPortraitBackgroundColor};
    `}
    ${media.mobileDevice`
         overflow: hidden;
    `}
`;

export const OrderDetailContainer = styled.div`
    display: block;
    width: 100%;
    height: ${({ isConsignmentReturn, isCallToActionEmpty }) =>
        isConsignmentReturn || isCallToActionEmpty ? 'calc(100% - 16px)' : 'calc(100% - 60px)'};
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    background: whitesmoke;

    ${({ isIPadPotrait }) =>
        isIPadPotrait &&
        css`
            ${StyledOrderDetailIPadPortrait}
        `};
    ${media.smalDevice`
        height: ${({ isConsignment, isCondensedViewHeight }) =>
            isCondensedViewHeight
                ? '100%'
                : isConsignment
                ? 'calc(116% - 85px)'
                : '100%'};
        border-top-right-radius: ${({ isCondensedView }) =>
            isCondensedView ? '0px' : '0px'};
        border-top-left-radius: ${({ isCondensedView }) =>
            isCondensedView ? '0px' : '0px'};
    `}

    ${media.mobileDevice`
        /* height: 100vh; */
        border-top-right-radius: ${({ isCondensedView }) =>
            isCondensedView ? '0px' : '20px'};
        border-top-left-radius: ${({ isCondensedView }) =>
            isCondensedView ? '0px' : '20px'};
    `}

    @media (max-width: 1000px) and (max-height: 500px) and (orientation: landscape) {
        height: ${({ isConsignmentReturn, isCallToActionEmpty }) =>
            isConsignmentReturn || isCallToActionEmpty ? 'calc(100% - 16px)' : 'calc(100% - 60px)'};
        overflow-y: auto;
    }
`;

export const OrderDetailBody = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 1rem 1rem 0 1rem;
    ${media.mobileDevice`
    padding: ${(props) => (props.padding ? props.padding : '1rem 1rem 0 1rem')};
    `}

    @media (max-width: 1000px) and (max-height: 500px) and (orientation: landscape) {
        height: auto;
        min-height: 100%;
        box-sizing: border-box;
    }
`;

export const OrderSurgeryFont = styled.div`
    width: ${({ isConsignmentAdd }) => (isConsignmentAdd ? '25%' : '')};
    margin: ${({ isMargin }) => (isMargin ? isMargin : '0')};
    margin-right: ${({ marginRight }) => marginRight};
    display: flex !important;
    font-family: ${({ isRegular, isDemi, isItalic }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi
            ? 'AvenirNextWorld Demi'
            : isItalic && 'AvenirNextWorld italic'};
    color: ${({ isSurgeyType, isSurgeyDate, isCenter }) =>
        isSurgeyType
            ? '#C529BB'
            : isSurgeyDate
            ? '#585858'
            : isCenter && '#4F4F4F'};
    font-size: ${({ isCenter }) => (isCenter ? '14px' : '12px')};
    line-height: ${({ isCenter }) => (isCenter ? '20px' : '21px')};
    opacity: 1;
    white-space: ${({ isConsignment }) => (isConsignment ? 'nowrap' : '')};
    word-break: ${({ wordBreak }) => wordBreak};
    ${media.mobileDevice`
     width: ${({ isConsignmentAdd }) => (isConsignmentAdd ? '50%' : '')};
       margin-left:${({ mobileMargin }) => (mobileMargin ? mobileMargin : '0')};
       font-size:${({ isCenter }) => (isCenter ? '14px' : '11px')};
    `} @media only screen and (max-width: 350px) {
        font-size: 10px;
    }
`;

export const SurgeryCenterContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 10px;
    ${media.mobileDevice`
        margin-top:${({ isConsignment }) => (isConsignment ? '3px' : '10px')};
        padding: ${(props) => props.padding};
    `}
`;

export const OrderDetailsTabs = styled.div`
    display: flex;
    width: 100%;
    box-sizing: border-box;
    margin-top: 10px;
    ${media.mobileDevice`
        margin-bottom : 2%;
        padding: ${(props) => props.padding};
    `}
`;

export const OrderDetailTabBodyContainer = styled.div`
    ${scrollBarStyle}
    flex-grow: 1;
    overflow-y: scroll;
    margin-top: 5px;
    padding-right: 10px;
    box-sizing: border-box;
    padding-bottom: ${({ isOrderHistory }) => (isOrderHistory ? '12px' : '0px')};

    ${media.mediumDevice`
        &::-webkit-scrollbar {
            display: none;
        }

        padding-right: 0;
        padding-bottom: 100px;
    `}

    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
        &::-webkit-scrollbar {
            display: none;
            width: 0;
        }
        padding-right: 0;
        padding-bottom: 100px;
    }

    ${media.smalDevice`
        &::-webkit-scrollbar {
            display: none;
            width: 0;
        }
        padding-right: 0;
        padding-bottom: 100px;
    `}

    ${media.mobileDevice`
        &::-webkit-scrollbar {
            display: none;
        }
      overflow-y: unset;

        padding-bottom: ${({isCallToActionEmpty, isCondensedView })=> isCallToActionEmpty ? (isCondensedView ? '0px' : '80px' ) : (isCondensedView ? '66px' : '120px')};
        padding-right: 0;
    `}

    @media (max-width: 1000px) and (max-height: 500px) and (orientation: landscape) {
        overflow-y: visible;
        flex-shrink: 0;
        padding-bottom: 16px;
    }
`;

export const OrderDetailTabBody = styled.div`
    display: flex;
    flex-direction: column;
    width: ${({ width }) => (width ? width : '99%')};
    margin: 0 auto;
    ${media.mobileDevice`
        width: ${({ mobileWidth }) => (mobileWidth ? mobileWidth : '')};
    `}
`;

export const OrderFooter = styled.div`
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    height: 3.5rem;
    display: flex;
    position: absolute;
    bottom: 0;
    background-color: #ffffff;
    box-shadow: 0px -3px 6px #00000014;
    opacity: 1;
    justify-content: flex-end;
    align-items: center;
    ${media.mobileDevice`
        justify-content: center;
    `}
`;

export const OrderDetailTitle = styled.p`
    margin: ${({ margin }) => (margin ? margin : '10px 0 10px 0')};
    cursor: ${({ cursor }) => cursor && cursor};
    font-weight: ${({ fontWeight }) => fontWeight && fontWeight};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Bold'};
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0px;
    color: #130e4a;
    opacity: 1;
    border-bottom: ${({ borderBottom }) =>
        borderBottom ? borderBottom : 'none'};
    border-bottom-width: ${({ borderBottomWidth }) =>
        borderBottomWidth ? borderBottomWidth : 'none'};
    ${media.mobileDevice`
        margin: ${({ mbMargin }) => mbMargin};
        margin-left: ${({ isCondensedView }) => isCondensedView && '15px'};
    `}
`;

export const OrderDetailFooterContainer = styled.div`
    width: 100%;
    display: flex;
    margin: 8px 0;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
`;
